import { render, staticRenderFns } from "./QuotaholderForm.vue?vue&type=template&id=e0cb2c7c&"
import script from "./QuotaholderForm.vue?vue&type=script&lang=js&"
export * from "./QuotaholderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports